import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2）。SFA 段階 5 §9.4: 通話の一覧・詳細・電話連携の設定 */
export const telephonyRoutes: RouteObject[] = [
  {
    path: '/telephony',
    lazy: async () => {
      const m = await import('./pages/CallListPage.js');
      return { Component: m.default };
    },
  },
  {
    path: '/telephony/calls',
    lazy: async () => {
      const m = await import('./pages/CallListPage.js');
      return { Component: m.default };
    },
  },
  {
    path: '/telephony/calls/:id',
    lazy: async () => {
      const m = await import('./pages/CallDetailPage.js');
      return { Component: m.default };
    },
  },
  {
    path: '/telephony/settings',
    lazy: async () => {
      const m = await import('./pages/TelephonySettingsPage.js');
      return { Component: m.default };
    },
  },
];
